import type { RouteRecordRaw } from 'vue-router';
import { allPromotion } from '@/pages/promotion/route';

export const promotionRoutes: RouteRecordRaw = {
  path: '/promotion',
  component: () => import('@/layouts/main.vue'),
  children: [
    ...allPromotion,
  ],
};

